import React, { lazy, Suspense } from 'react'
import ErrorBoundary from 'common/components/ErrorBoundary'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'

import Teacher from './teacher'

import packageJson from '../package.json'

const ControlRoomApp = lazy(() => import('./controlRoom'))

const Student = lazy(() => import('./student'))

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route
            path='/app/control-room/*'
            element={
              <Suspense fallback={<Box>Loading...</Box>}>
                <ControlRoomApp />
              </Suspense>
            }
          />
          <Route
            path='/app/student/*'
            element={
              <Suspense fallback={<Box>Loading...</Box>}>
                <Student />
              </Suspense>
            }
          />
          <Route path='/app/teacher/*' element={<Teacher />} />
          <Route path='/' element={<Navigate to='/app/student' replace />} />
          <Route
            path='/app/version'
            element={<div>Version {packageJson.version}</div>}
          />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
